import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import { invalidateStockEntryPipeline } from "../../production/hooks/useSowingLifecycle";
import {
  greenhouseStockTakeApi,
  type SaveStockTakeRequest,
  type StockTakeParams,
} from "../services/greenhouseStockTakeApi";

export const useGreenhouseStockTake = (params: StockTakeParams) =>
  useQuery({
    queryKey: ["greenhouse-stock-take", params],
    queryFn: () => greenhouseStockTakeApi.get(params),
    placeholderData: (previous) => previous,
  });

export const useSaveGreenhouseStockTake = () =>
  useMutation({
    mutationFn: ({ stockEntryId, payload }: { stockEntryId: string; payload: SaveStockTakeRequest }) =>
      greenhouseStockTakeApi.saveBeds(stockEntryId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["greenhouse-stock-take"] });
      // A save rewrites placements (and possibly the entry's greenhouse), so the
      // stock, lifecycle, and layout screens must refresh too.
      invalidateStockEntryPipeline();
    },
  });
